import script from "./item-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./item-info.vue?vue&type=script&setup=true&lang=ts"

import "./item-info.vue?vue&type=style&index=0&id=2c447e33&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c447e33"]])

export default __exports__